import type { SourceChannelsBundle } from '../ru/source-channels';

export const sourceChannelsEn: SourceChannelsBundle = {
  kind: {
    events: 'Events',
    news: 'News',
  },
  delete: {
    button: 'Delete channel',
    confirmTitle: 'Delete channel "{{title}}"?',
    confirmDescription:
      'This action cannot be undone. All collected messages will be unlinked or deleted along with the channel — check the backend contract. If the channel has queued DRAFT events, the deletion may be rejected by the server.',
    confirmHintPrefix: 'To confirm, type ',
    confirmHintSuffix: ':',
    slugPlaceholder: 'Enter slug',
    cancel: 'Cancel',
    deletingEllipsis: 'Deleting…',
    confirm: 'Delete',
    success: 'Channel deleted',
    error: 'Failed to delete',
  },
  form: {
    slugLabel: 'Channel or forum topic',
    slugPlaceholder: 'hcmc_events or https://t.me/ActiveTimeGe/8270',
    slugHintPart1: 'Latin letters, digits, ',
    slugHintPart2: '. You can use ',
    slugHintPart3: ' — it will be normalized.',
    slugHintTopic:
      'Add a forum topic as a link like t.me/group/8270 — the import only picks up posts carrying a date hashtag.',
    slugImmutableHint: 'Slug cannot be changed — recreate the channel.',
    topicLabel: 'Forum topic',
    walkLabel: 'Id walk (flat chat)',
    walkPlaceholder: 'https://t.me/group/31842 or 31842',
    walkHint:
      'For supergroups with neither a web feed nor topics: paste a link to any recent message — the import walks forward by id from it and picks up posts carrying a date hashtag. Leave empty for a regular channel.',
    walkCursorLabel: 'Walk cursor',
    walkResetLabel: 'Move the walk cursor',
    walkResetHint:
      'The cursor gets stuck on a large gap in the chat numbering or a wrong start id. Paste a link to a recent message — the walk resumes from it. Leave empty to keep it as is.',
    titleAutoHint: 'The channel title will be pulled automatically from Telegram after creation.',
    titleLabel: 'Title',
    titlePlaceholder: 'HCMC Events',
    cityLabel: 'City',
    selectCity: 'Select city',
    kindLabel: 'Type',
    kindHint: 'Events — extracted via LLM, then manual moderation. News — published to the feed directly.',
    cadenceLabel: 'Fetch cadence (minutes)',
    cadenceHint: 'From 5 to 1440 minutes. Default is 15.',
    activeLabel: 'Active',
    submitCreate: 'Add',
    submitSave: 'Save',
    createSuccess: 'Channel added',
    updateSuccess: 'Changes saved',
  },
  table: {
    headerSlug: 'Slug',
    headerTitle: 'Title',
    headerCity: 'City',
    headerLastFetch: 'Last fetch',
    headerErrors: 'Errors',
    headerMessages: 'Messages',
    headerKind: 'Type',
    headerStatus: 'Status',
    headerActions: 'Actions',
    statusActive: 'Active',
    statusDisabled: 'Disabled',
    open: 'Open',
    fetchNowTitle: 'Fetch now',
    fetchNowSuccess: 'Fetch started',
    fetchNowError: 'Failed to start fetch',
    emptyTitle: 'No sources yet',
    emptyDescription: 'Add a Telegram channel to automatically collect events.',
    addChannel: 'Add channel',
  },
};
